export type WorkType = "TV动画" | "剧场版" | "OVA";
export type WorkRegion = "日本" | "中国" | "欧美";

export type WorkItem = {
  id: string;
  title: string;
  originalTitle: string;
  cover: string;
  type: WorkType;
  region: WorkRegion;
  year: number;
  episodes: string;
  studio: string;
  summary: string;
  description: string[];
  tags: string[];
  favoriteCount: number;
  updatedAt: string;
  characterIds: string[];
  trailerTitle: string;
  trailerDuration: string;
};

export const worksList: WorkItem[] = [
  {
    id: "w-001",
    title: "星海回响",
    originalTitle: "ECHOES OF THE STAR SEA",
    cover: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20young%20pilot%20in%20a%20white%20and%20orange%20flight%20suit%20standing%20before%20a%20towering%20starship%2C%20deep%20navy%20space%20background%20with%20warm%20amber%20nebula%2C%20cinematic%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=800&height=1000&seq=age-work-001&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2025,
    episodes: "全 24 集",
    studio: "晨星动画制作",
    summary:
      "一艘老旧货船、一条被废弃的深空航线，和一群没有归处的人。原创机甲动画，用克制的叙事讲述关于「回望」的旅程。",
    description: [
      "《星海回响》是一部以星际航行为舞台的原创动画。故事从一艘即将退役的货船开始，主角凌星野在一次意外中被迫接管航行任务，与一群来历各异的船员踏上一条早已被标记为废弃的航线。",
      "作品在机甲设定上偏向工业写实，机体的接缝、磨损与补漆痕迹都被细致保留。导演曾表示，团队希望这些机械看起来是「被使用过的」，而不是展台上的模型。",
      "叙事节奏是本作最受讨论的部分。它愿意花整整一集的时间去描写一次补给、一次维修，甚至是船员之间一段无关紧要的对话。这些片段最终在结局处汇成了相当有力的情绪。",
      "配乐由长期合作的原声团队负责，大量使用合成器铺底，在关键段落反而撤掉节奏乐器，以留白完成情绪推进。",
    ],
    tags: ["原创动画", "机甲", "科幻", "群像"],
    favoriteCount: 28450,
    updatedAt: "2026-10-15",
    characterIds: ["c-001", "c-002"],
    trailerTitle: "第二季先导预告 · 深空航线",
    trailerDuration: "01:32",
  },
  {
    id: "w-002",
    title: "赤月战线",
    originalTitle: "CRIMSON FRONTIER",
    cover: "https://readdy.ai/api/search-image?query=Anime%20action%20poster%20of%20a%20silhouetted%20swordsman%20with%20a%20crimson%20blade%20under%20a%20huge%20red%20moon%2C%20embers%20and%20dark%20navy%20smoke%2C%20dramatic%20orange%20rim%20light%2C%20minimal%20typography%20space%2C%20cinematic%20illustration&width=800&height=1000&seq=age-work-002&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    episodes: "全 12 集",
    studio: "赤羽工作室",
    summary:
      "赤月升起的夜晚，边境的剑士团迎来了最后一场战役。以动作演出见长的硬派作品，第三集战斗回被观众称为本季最佳。",
    description: [
      "《赤月战线》讲述了一支驻守边境的剑士团，在赤月异象出现后的十二个夜晚里所经历的一切。作品采用单元剧与主线交织的结构，每一集聚焦一位团员的选择。",
      "动作演出是本作最突出的部分。制作组刻意减少了快速剪辑的使用，转而通过环境音、呼吸与留白来制造压迫感。第三集的七分钟战斗已成为本季讨论度最高的段落之一。",
      "角色塑造方面，主角黑川凛并非传统意义上的强者。她的每一次胜利都伴随着明确的代价，剧本也从未试图掩盖这一点。",
      "美术风格偏向低饱和的暗色调，唯有月光与刀光保留了高亮，形成了极具辨识度的视觉语言。",
    ],
    tags: ["热血", "战斗", "奇幻", "硬派"],
    favoriteCount: 24180,
    updatedAt: "2026-10-12",
    characterIds: ["c-003"],
    trailerTitle: "正式预告 · 赤月之夜",
    trailerDuration: "01:48",
  },
  {
    id: "w-003",
    title: "雨巷食堂",
    originalTitle: "THE ALLEY DINER",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20of%20a%20small%20wooden%20diner%20in%20a%20rainy%20alley%20at%20dusk%2C%20warm%20lantern%20light%2C%20steam%20rising%20from%20a%20bowl%2C%20deep%20navy%20blue%20rain%20and%20orange%20glow%2C%20soft%20illustrated%20texture%2C%20tranquil%20mood&width=800&height=1000&seq=age-work-003&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    episodes: "全 12 集",
    studio: "小满制作组",
    summary:
      "雨巷深处的一家小食堂，一位话不多的店主，一季来来去去的客人。把治愈拍成一种生活节奏的日常番。",
    description: [
      "这是一部几乎没有主线冲突的日常作品。每一集，一位客人推开木门，点一份并不复杂的饭菜，在一顿饭的时间里慢慢松开紧绷的肩膀。",
      "作品对食物的处理近乎固执。从切菜的刀工到汤面的浮油，每一个步骤都被完整呈现。这些镜头并不追求食欲上的刺激，而是营造一种被照顾的踏实感。",
      "店主的过去在整季中被反复暗示，却始终没有被完整交代。这种留白让作品保持了一种恰到好处的距离感。",
      "如果你需要一部不需要倍速的动画，它大概会是很长一段时间里的首选。",
    ],
    tags: ["治愈", "日常", "美食", "慢节奏"],
    favoriteCount: 31260,
    updatedAt: "2026-10-10",
    characterIds: ["c-004"],
    trailerTitle: "开播预告 · 今日例汤",
    trailerDuration: "01:05",
  },
  {
    id: "w-004",
    title: "剑鸣之诗",
    originalTitle: "HYMN OF BLADES",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20poster%20of%20a%20young%20swordsman%20holding%20a%20long%20blade%20on%20a%20stone%20terrace%2C%20golden%20sunset%20light%2C%20deep%20navy%20cloak%2C%20wind%20blown%20fabric%2C%20minimal%20mountain%20background%2C%20painterly%20cinematic%20illustration&width=800&height=1000&seq=age-work-004&orientation=portrait",
    type: "剧场版",
    region: "日本",
    year: 2026,
    episodes: "剧场版 · 118 分钟",
    studio: "白鸦映画",
    summary:
      "剑士团解散后的第三年，阿尔文收到了一封没有署名的信。剧场版延续电视版的世界观，以更密集的动作场面完成一段告别。",
    description: [
      "作为电视版的剧场版续作，本作的时间线设定在故事结束三年之后。曾经的剑士团早已解散，成员各自散落，主角阿尔文则在一座边境小镇以修理武器为生。",
      "剧场版的动作场面密度明显高于电视版。制作组启用了新的作画班底，几场多人混战的调度相当复杂，但始终保持着清晰的空间关系。",
      "与密集的动作相对，作品的文戏部分反而更加安静。大量时间被留给了角色之间的沉默与对视，这种节奏上的对比构成了整部影片的情绪骨架。",
      "影片的结尾没有安排盛大的胜利，只有一场简短的告别。这或许是主创团队想说的最后一句话。",
    ],
    tags: ["剧场版", "剑戟", "奇幻", "告别"],
    favoriteCount: 19870,
    updatedAt: "2026-10-08",
    characterIds: ["c-005"],
    trailerTitle: "剧场版特报 · 三年之后",
    trailerDuration: "02:04",
  },
  {
    id: "w-005",
    title: "灵能事务所",
    originalTitle: "PARANORMAL AGENCY",
    cover: "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20cluttered%20paranormal%20investigation%20office%20at%20night%2C%20glowing%20paper%20talismans%2C%20warm%20orange%20desk%20lamp%2C%20deep%20navy%20shadows%2C%20mysterious%20silhouette%20in%20the%20doorway%2C%20cinematic%20illustration&width=800&height=1000&seq=age-work-005&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2025,
    episodes: "全 13 集",
    studio: "夜灯动画",
    summary:
      "一间开在旧楼三层的灵能事务所，专门处理那些不被官方承认的委托。都市奇幻题材，单元案件与主线谜团交替推进。",
    description: [
      "作品的舞台是一座正在被重新开发的旧城区。主角白砚经营着一间勉强维持运转的灵能事务所，接手的委托大多琐碎、古怪，且报酬微薄。",
      "每个单元案件都有独立的谜面，但所有线索最终都会指向同一个源头。剧本在处理悬念时相当克制，很少给出明确的解释，更多时候让观众自行拼合。",
      "美术与色彩设计是本作的一大亮点。旧楼、霓虹、雨夜与符纸上的朱红构成了鲜明的视觉符号，气氛营造非常到位。",
      "第二季已进入企划阶段，官方尚未公布具体时间。",
    ],
    tags: ["都市奇幻", "悬疑", "单元剧", "灵异"],
    favoriteCount: 17640,
    updatedAt: "2026-09-30",
    characterIds: ["c-006"],
    trailerTitle: "第一季回顾 · 未被记录的委托",
    trailerDuration: "01:26",
  },
  {
    id: "w-006",
    title: "夏日回声",
    originalTitle: "SUMMER ECHO",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20anime%20poster%20of%20two%20teenagers%20on%20a%20seaside%20railway%20platform%20in%20summer%2C%20bright%20warm%20sunlight%2C%20deep%20blue%20ocean%2C%20soft%20lens%20flare%2C%20minimal%20clean%20composition%2C%20gentle%20emotional%20mood&width=800&height=1000&seq=age-work-006&orientation=portrait",
    type: "剧场版",
    region: "日本",
    year: 2026,
    episodes: "剧场版 · 96 分钟",
    studio: "海风工作室",
    summary:
      "毕业前的最后一个夏天，两个少年决定沿着海岸线走完那段废弃的铁路。一部关于告别与未说出口的话的青春小品。",
    description: [
      "《夏日回声》的故事极其简单：两个高中三年级的少年，在毕业前的最后一个暑假，决定沿着海岸线走完一段早已停运的铁路。",
      "影片没有设置反派，也没有戏剧化的转折。冲突来自那些没有说出口的话，以及即将到来的分别。导演用了大量固定镜头拍摄风景，让人物的沉默拥有了重量。",
      "色彩是这部作品最重要的语言。整部影片的亮度被刻意提高，海面与天空几乎融在一起，只有人物的影子提醒观众时间的流逝。",
      "片尾曲响起时，镜头停留在一段空荡的站台上。这大概是今年夏天最安静的一个结尾。",
    ],
    tags: ["青春", "剧场版", "治愈", "夏日"],
    favoriteCount: 22310,
    updatedAt: "2026-09-27",
    characterIds: [],
    trailerTitle: "正式预告 · 海边的最后一段路",
    trailerDuration: "01:41",
  },
  {
    id: "w-007",
    title: "机械花园",
    originalTitle: "MECHANICAL GARDEN",
    cover: "https://readdy.ai/api/search-image?query=Surreal%20anime%20poster%20of%20a%20glass%20greenhouse%20filled%20with%20blooming%20mechanical%20flowers%2C%20a%20lone%20child%20silhouette%2C%20warm%20amber%20light%20through%20glass%2C%20deep%20navy%20shadows%2C%20delicate%20linework%2C%20dreamlike%20editorial%20art&width=800&height=1000&seq=age-work-007&orientation=portrait",
    type: "OVA",
    region: "日本",
    year: 2026,
    episodes: "全 4 集",
    studio: "玻璃温室企划",
    summary:
      "一座培育机械花的温室，一个负责浇水的孩子，和一段正在被遗忘的记忆。四集篇幅的安静寓言。",
    description: [
      "这是一部只有四集的 OVA 作品。舞台是一座孤立在荒原上的玻璃温室，里面培育着会随季节开合的机械花。主角阿澈是唯一的照料者，也是唯一还记得温室来历的人。",
      "作品以极简的叙事展开，每一集对应一个季节。没有激烈的冲突，所有的转折都发生在细微的动作与停顿之间。",
      "机械花的设定充满隐喻。它们按照既定程序盛开、凋谢，却在某一集开始出现无法解释的偏差。这个细节成为了整部作品的核心谜题。",
      "作为一部实验性较强的短篇作品，《机械花园》证明了篇幅与野心并不总是正相关。",
    ],
    tags: ["OVA", "科幻", "寓言", "实验"],
    favoriteCount: 12480,
    updatedAt: "2026-09-24",
    characterIds: ["c-007"],
    trailerTitle: "OVA 预告 · 第四个季节",
    trailerDuration: "01:12",
  },
  {
    id: "w-008",
    title: "山海异闻录",
    originalTitle: "CHRONICLES OF MOUNTAINS AND SEAS",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20anime%20poster%20of%20a%20scholar%20with%20a%20scroll%20walking%20through%20misty%20mountains%20beside%20a%20mythical%20winged%20creature%2C%20terracotta%20and%20deep%20indigo%20palette%2C%20elegant%20negative%20space%2C%20cinematic%20composition&width=800&height=1000&seq=age-work-008&orientation=portrait",
    type: "TV动画",
    region: "中国",
    year: 2026,
    episodes: "全 12 集",
    studio: "青川动画",
    summary:
      "一个负责记录异闻的普通书生，带着一卷未完的手稿走过山川。国创动画以水墨质感重新讲述古老意象。",
    description: [
      "《山海异闻录》改编自多部古籍中的志怪条目，却并未采用传统的神话剧结构。主角云翼是一位负责记录异闻的书生，他的工作只是观察、记录，而不介入。",
      "作品的推进方式接近公路片，一集一个地点、一段相遇。每一集都有独立的小故事，最终在结尾处汇成一条完整的情感线索。",
      "美术是最受关注的部分。制作团队开发了专用的笔触处理工具，让三维场景在渲染后保留手绘的不规则边缘，形成介于水墨与赛璐璐之间的独特质感。",
      "配乐使用了大量传统乐器，但编曲方式相当现代，与画面形成了有趣的对话。",
    ],
    tags: ["国创", "东方美学", "志怪", "公路片"],
    favoriteCount: 26720,
    updatedAt: "2026-10-14",
    characterIds: ["c-008"],
    trailerTitle: "定档预告 · 一卷未完的手稿",
    trailerDuration: "02:18",
  },
  {
    id: "w-009",
    title: "零号列车",
    originalTitle: "TRAIN ZERO",
    cover: "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20an%20empty%20vintage%20train%20carriage%20at%20night%20with%20warm%20amber%20lamps%20and%20a%20dark%20window%20reflecting%20a%20silhouette%2C%20deep%20navy%20tones%2C%20slightly%20surreal%20atmosphere%2C%20cinematic%20composition&width=800&height=1000&seq=age-work-009&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    episodes: "全 11 集",
    studio: "终点站制作委员会",
    summary:
      "一列永不到站的列车，一群记不清自己名字的乘客。用悬疑外壳包裹的记忆与身份寓言。",
    description: [
      "故事开始于一个没有记忆的男人在列车上醒来。车厢里坐满了乘客，没有人知道列车从哪里出发，也没有人记得自己为什么在这里。",
      "每一集，列车会停靠一个站台，但车门只打开很短的时间。有人下车，有人上车，而主角祁夜开始注意到，某些乘客的面孔在不同车厢里重复出现。",
      "作品的悬疑设计相当扎实，线索公平地摆在观众面前，却不会过早暴露答案。导演在采访中提到，整部作品的剧本在开拍前就已经完成了完整的时间线推演。",
      "美术与音效是氛围营造的关键。列车行进的节奏被直接采样进配乐，成为贯穿全剧的声音母题。",
    ],
    tags: ["悬疑", "科幻", "记忆", "群像"],
    favoriteCount: 18960,
    updatedAt: "2026-10-06",
    characterIds: ["c-009"],
    trailerTitle: "首播预告 · 下一站，未知",
    trailerDuration: "01:37",
  },
  {
    id: "w-010",
    title: "猫与旧书店",
    originalTitle: "THE CAT AND THE OLD BOOKSHOP",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20poster%20of%20a%20tiny%20old%20bookshop%20with%20floor%20to%20ceiling%20bookshelves%2C%20a%20sleeping%20orange%20cat%20on%20a%20wooden%20counter%2C%20dust%20in%20golden%20afternoon%20light%2C%20cozy%20nostalgic%20illustration&width=800&height=1000&seq=age-work-010&orientation=portrait",
    type: "OVA",
    region: "日本",
    year: 2025,
    episodes: "全 3 集",
    studio: "纸页工作室",
    summary:
      "旧书店的店主与一只总在午后出现的橘猫。三集短篇，关于书、关于陪伴，也关于一间店慢慢被记住的过程。",
    description: [
      "这是一部长度不到一小时的短篇合集。场景几乎全部发生在一间狭小的旧书店里，出现的角色不超过五个人，以及一只神出鬼没的橘猫。",
      "作品的魅力来自细节。书页翻动的声响、午后阳光里浮动的灰尘、猫在柜台上换姿势时的重量感，都被细致地保留下来。",
      "三集分别对应三个季节，时间线并不连贯，却在最后一集悄悄收束。这种结构让作品重看时会发现许多此前忽略的线索。",
      "它不试图讲什么大道理，只是安静地陪观众坐一会儿。",
    ],
    tags: ["OVA", "治愈", "日常", "书与猫"],
    favoriteCount: 14120,
    updatedAt: "2026-09-18",
    characterIds: [],
    trailerTitle: "短篇预告 · 午后三点的客人",
    trailerDuration: "00:58",
  },
  {
    id: "w-011",
    title: "苍蓝纪元",
    originalTitle: "AZURE EPOCH",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20sci-fi%20poster%20of%20a%20floating%20city%20above%20a%20deep%20blue%20ocean%2C%20a%20lone%20figure%20on%20a%20platform%2C%20warm%20orange%20sunrise%20breaking%20through%20clouds%2C%20minimal%20architectural%20shapes%2C%20cinematic%20wide%20composition&width=800&height=1000&seq=age-work-011&orientation=portrait",
    type: "剧场版",
    region: "日本",
    year: 2025,
    episodes: "剧场版 · 132 分钟",
    studio: "苍蓝映画",
    summary:
      "海平面上升后的第七十年，人类把城市建在了云层之上。一部关于文明代价的科幻剧场版，画面规格极高。",
    description: [
      "《苍蓝纪元》构建了一个极具说服力的近未来世界：海平面上升七十年后，幸存的人类将城市建在高空平台上，依靠复杂的循环系统维持生存。",
      "影片的叙事从一名维修工程师的日常开始。他在一次例行检修中发现,系统的某处数据被人为修改。这条线索将他引向了被刻意掩埋的过去。",
      "美术设定是这部作品最值得称道的部分。云层、平台、升降井与废弃的旧城区在视觉上形成了清晰的层级关系，每一处场景都在讲述这个世界的运行逻辑。",
      "影片的时长达到 132 分钟，中段略显沉重，但结尾那段长达六分钟的无对白长镜头，足以让人原谅所有的铺垫。",
    ],
    tags: ["剧场版", "科幻", "末世", "设定"],
    favoriteCount: 25430,
    updatedAt: "2026-09-12",
    characterIds: [],
    trailerTitle: "剧场版正式预告 · 云上的城市",
    trailerDuration: "02:26",
  },
  {
    id: "w-012",
    title: "星屑骑士团",
    originalTitle: "STARDUST KNIGHTS",
    cover: "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20three%20young%20knights%20in%20ornate%20armor%20standing%20on%20a%20glowing%20star%20map%20floor%2C%20warm%20gold%20and%20deep%20navy%20palette%2C%20floating%20light%20particles%2C%20clean%20heroic%20composition%2C%20high%20detail%20illustration&width=800&height=1000&seq=age-work-012&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2024,
    episodes: "全 24 集",
    studio: "星屑企划",
    summary:
      "三位年轻的骑士，一张会随星象改变的契约书。王道奇幻的扎实回归，角色群像与世界观同样出色。",
    description: [
      "在一个由星象决定秩序的大陆上，三位年轻人被同一份契约书选中。他们分别来自不同的城邦，抱着完全不同的目的成为骑士。",
      "作品在奇幻设定上下了很大功夫。星象、契约与骑士团的等级制度相互咬合，形成了一套逻辑自洽的体系，而不是单纯为战斗服务的背景板。",
      "三位主角的关系描写是最大亮点。剧本没有安排刻意的和解桥段，而是让分歧一直存在，只是随着故事推进，他们学会了在分歧中继续同行。",
      "第二季的制作已进入筹备，官方在近期活动中放出了一张概念图。",
    ],
    tags: ["奇幻", "王道", "群像", "冒险"],
    favoriteCount: 30120,
    updatedAt: "2026-09-08",
    characterIds: [],
    trailerTitle: "第一季回顾 · 星象之下",
    trailerDuration: "01:50",
  },
];

export const workTypes: Array<WorkType | "全部"> = ["全部", "TV动画", "剧场版", "OVA"];
export const workRegions: Array<WorkRegion | "全部"> = ["全部", "日本", "中国", "欧美"];
export const workYears = ["全部", "2026", "2025", "2024"];

export const getWorkById = (id?: string) => worksList.find((item) => item.id === id);